import PageShell from "./PageShell";
import About from "@/components/site/About";
import Ethos from "@/components/site/Ethos";
import Founder from "@/components/site/Founder";

export default function AboutPage() {
  return (
    <PageShell testId="page-about">
      <About />
      <Ethos />
      <Founder />
    </PageShell>
  );
}
